/**
 * Controls whether organization / org-customer screens call the backend.
 *
 * - Default: **on** (APIs run) so Save works without extra env setup.
 * - To use **local seed data only** and skip all organization HTTP calls, set in `.env`:
 *   `REACT_APP_USE_ORGANIZATION_API=false`
 */
export function isOrganizationApiEnabled() {
  const v = process.env.REACT_APP_USE_ORGANIZATION_API;
  if (v == null || v === "") return true;
  return String(v).toLowerCase() !== "false" && String(v) !== "0";
}
